import { memo, useEffect } from 'react';
import Modal from 'react-modal';
import * as styles from './styles';

export type Props = {
  children?: React.ReactNode;
  visible?: boolean;
  onClose?: () => void;
  [key: string]: any;
};

Modal.setAppElement('#__next');

function BottomSheet({
  children,
  visible = false,
  onClose = () => {},
  ...args
}: Props) {
  const init = () => {
    if (visible) {
      //dimmed 영역 스크롤 막기
      document.body.classList['add']('persistent');
    } else {
      document.body.classList['remove']('persistent');
    }
  };
  useEffect(init, [visible]);

  const handleContentClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
  };

  return (
    <Modal
      closeTimeoutMS={200}
      isOpen={visible}
      onRequestClose={onClose}
      style={styles.modal}
      {...args}
    >
      <div css={styles.wrap} onClick={onClose}>
        <div css={styles.content} onClick={handleContentClick}>
          {children}
        </div>
      </div>
    </Modal>
  );
}

export default memo(BottomSheet);
